{
  "page": {
    "login": {
      "title": "Login with",
      "sso": {
        "button_title_main": "Single sign-on",
        "button_title_annotation": "Using company identity provider",
        "subtitle": "Company account",
        "use_password": "Use Email & Password"
      },
      "password": {
        "button_title_main": "Email & Password",
        "button_title_annotation": "Using account credentials",
        "subtitle": "Email and password",
        "use_sso": "Use Single Sign-On"
      },
      "heading": "Simplifying safe data storage",
      "subheading": "Scalefield makes managing and storing your data the simplest and most uncomplicated task in the world - whilst maintaining highest security.",
      "login_button": "Sign In",
      "sso_login_button": "Continue with Single Sign-On",
      "continue_with_button": "Single Sign-On with {{name}}",
      "or": "Or",
      "sign_up": "Sign up",
      "not_registered": "Don't have an account?",
      "already_registered": "Already have an account?",
      "error": {
        "unprocessable_entity": "Incorrect email or password. Try again or click <strong>Forgot password</strong> to reset it.",
        "invalid_credentials": "Incorrect email or password. Try again or click <strong>Forgot password</strong> to reset it.",
        "duplicate_email": "Email address already registered",
        "invalid_language": "Invalid language",
        "uncaught_error": "An error has occurred",
        "no_invitation": "Only invited users may register on Scalefield. Please contact your respective superuser to receive an invitation.",
        "system_not_available": "The system is currently not available. Please try again later.",
        "network_error": "Network error",
        "invalid_client": "There was a problem with the SSO configuration. Please contact your superuser.",
        "invalid_request": "There was a problem with idP configured for your SSO. Please contact your superuser.",
        "not_authorized": "This account is not authorized to be used with SSO. Please contact your superuser."
      },
      "continue_with_separator": "Or continue with:"
    },
    "sso": {
      "title": "Login with SSO",
      "annotation": "Enter your work email to sign in using your company’s identity provider",
      "options": {
        "edit_email": "Edit email address",
        "basic": "It looks like this profile was created using <b>Basic Authentication</b>",
        "continue_with_basic": "Continue with Basic Authentication",
        "create_new_account": "Create new account",
        "no_profile_match": "Looks like you’re new here! We matched your email domain to the following organizations. Choose one to sign up, or <l>create a brand new account</l>",
        "no_domain_match": "Looks like you’re new here! We couldn’t find any organizations matching your email domain. You may still <l>create a new account</l> to get started"
      },
      "callback": {
        "loading": "Authenticating your account... This will only take a moment.",
        "failed": "Sign-in Failed",
        "failed_detailed": "We couldn't complete the authentication process.",
        "show_error": "Show technical details...",
        "hide_error": "Hide technical details...",
        "return_to_login": "Return to login",
        "errors": {
          "cookie_missing": {
            "error": "Some required identification cookies are missing.",
            "hint": "This might happen if the login session timed out or if your browser is blocking cookies."
          },
          "token_fetch_failed": {
            "error": "Scalefield was unable to retrieve user information from the authentication callback.",
            "hint": "This is often caused by a configuration issue, such as an invalid client secret or redirect URI."
          },
          "group_claim": {
            "error": "The group attribute specified in your OIDC configuration was not found in the identity provider's response.",
            "hint": "Please review the technical details below to see which attributes were returned by your IdP."
          },
          "email_collision": {
            "error": "The email associated with your OIDC account is already linked to an existing user.",
            "hint": "Please log in with that account and remove it first, or contact the Scalefield support team for assistance."
          },
          "uncaught": {
            "error": "Something went wrong and wasn't handled as expected.",
            "hint": "Please contact our Support team or open a bug report so we can investigate."
          }
        }
      }
    },
    "forgot_password": {
      "title": "Forgot password?",
      "back_to_login": "Back to login",
      "send_reset_email": "Send reset email",
      "email_was_sent": "Email was sent"
    },
    "link_expired": {
      "sub_title": "You can resent the confirmation from your profile"
    },
    "recovery_password": {
      "title": "Password Recovery",
      "sub_title": "Welcome back!",
      "description": "Please enter your new password.",
      "new_password": "New password",
      "confirm_password": "Confirm password",
      "submit_button": "Submit",
      "error": {
        "unprocessable_entity": "Incorrect password",
        "different_passwords": "different passwords"
      }
    }
  },
  "validation": {
    "email": {
      "invalid_email": "Enter a valid email",
      "empty": "Email is required"
    },
    "password": {
      "invalid_password": "Password must contain at least 8 characters, one uppercase letter, one lowercase letter and a digit",
      "empty": "Enter your password"
    },
    "confirmPassword": {
      "valid": "Passwords do not match",
      "required": "Confirm your password"
    },
    "firstName": {
      "empty": "First name is required"
    },
    "lastName": {
      "empty": "Last name is required"
    },
    "is_marketable": {
      "required": "Agree terms is required"
    }
  }
}
